module.exports = __webpack_public_path__ + "img/chang.e216faf3.svg";